import React from 'react'
import { useParams } from 'react-router-dom'
import { CardTransactionsContent } from './CardTransactionDetails/CardTransactionsContent'
import { CardTransactionsFilters } from './CardTransactionsFilters'
import { useCardTransactionsFilters } from './hooks/useCardTransactionsFilters'

export const CardTransactionsTable = () => {
  const { id: customerId = '' }: { id?: string } = useParams()
  const { searchQuery, setSearchQuery, dateRange, setDateRange, queryString, isSearching } =
    useCardTransactionsFilters(customerId)

  return (
    <>
      <CardTransactionsFilters
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        dateRange={dateRange}
        onDateRangeChange={setDateRange}
      />
      <CardTransactionsContent
        queryString={queryString}
        isSearching={isSearching}
        onClearSearch={() => setSearchQuery('')}
      />
    </>
  )
}
